import { useEffect, useState } from "react";

import { get } from "../apiClient";

export const useData = (service, path, params = {}) => {
  const [data, setData] = useState({ loading: false, data: null, error: null });
  const serializedParams = JSON.stringify(params ?? {});

  useEffect(() => {
    let ignore = false;
    const parsedParams = JSON.parse(serializedParams);

    setData((prev) => ({ ...prev, loading: true }));
    get(service, path, { params: parsedParams })
      .then((response) => {
        if (!ignore) {
          setData({ loading: false, data: response, error: null });
        }
      })
      .catch((error) => {
        if (!ignore) {
          setData({ data: null, loading: false, error });
        }
      });

    return () => {
      ignore = true;
    };
  }, [service, path, serializedParams]);

  return data;
};
